import axios from 'axios'

export default async function (env, path, error, params) {
  function removeStartAndTrailingSlash(str) {
    return str.replace(/^\/|\/$/g, '').replace(/^\/|\/$/g, '')
  }

  const slug = removeStartAndTrailingSlash(path)

  const locals = {
    es: 'es',
    de: 'de',
    it: 'it',
    pt: 'pt',
    fr: 'fr',
    da: 'da',
    id: 'id',
  }

  let langCode = 'en'
  for (let localsKey in locals) {
    if (path.startsWith(`${localsKey}/`)) {
      langCode = locals[localsKey]
    }
  }

  const res = await axios
    .get(`${env.CMS_URL}/api/pages/?filters[slug]=${slug}&populate=deep,10${params ? params : ''}&locale=${langCode}`, {
      headers: { Authorization: `Bearer ${env.CMS_KEY}` },
    })
    .catch((err) => {
      return error({ statusCode: 500, message: err })
    })

  if (res.data.data.length !== 1) {
    return error({ statusCode: 404, message: 'Page not found' })
  }

  //https://stackoverflow.com/questions/12539574/whats-the-best-way-most-efficient-to-turn-all-the-keys-of-an-object-to-lower
  // e.g. attributes.Body -> attributes.body, attributes.Body.Title -> attributes.body.title
  let objectKeysToLowerCase = function (input) {
    if (typeof input !== 'object') return input
    if (Array.isArray(input)) return input.map(objectKeysToLowerCase)
    return Object.keys(input).reduce(function (newObj, key) {
      let val = input[key]
      newObj[key[0].toLowerCase() + key.slice(1)] = typeof val === 'object' && val !== null ? objectKeysToLowerCase(val) : val
      return newObj
    }, {})
  }

  var currentTime = new Date()
  const month = currentTime.toLocaleString('default', { month: 'long' })
  const day = currentTime.getDate()
  const year = currentTime.getFullYear()

  const pageDataString = JSON.stringify(objectKeysToLowerCase(res.data.data[0]))
  const pageData = JSON.parse(pageDataString.replaceAll('{{month}}', month).replaceAll('{{day}}', day).replaceAll('{{year}}', year))
  return pageData
}
